

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import { useMediaQuery } from 'react-responsive'

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
// Material components
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Grid from '@material-ui/core/Grid';
//import Tooltip from '@material-ui/core/Tooltip';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/Help';
import IconButton from '@material-ui/core/IconButton';
import StopIcon from '@material-ui/icons/Stop';
import Divider from '@material-ui/core/Divider';
import Popover from '@material-ui/core/Popover';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import {getObjectives} from '../../../../services/getObjectives'
import Hidden from '@material-ui/core/Hidden';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ClearIcon from '@material-ui/icons/Clear';

// Component styles
import moment from 'moment-timezone'
import 'moment/locale/es'
import AvailabilityObjective from './AvailabilityObjective';
import FilterService from './Filter';
import {getAvailabilityObjetive} from './../../../../services/getAvailability'
import ListObjectiveModal from '../ListObjectiveModal';
moment.locale('es')

const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1025 })
    return isDesktop ? children : null
  }
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
  }
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
  }
  const Default = ({ children }) => {
    const isNotMobile = useMediaQuery({ minWidth: 768 })
    return isNotMobile ? children : null
  }

class FastView extends Component {
    constructor(props) {
        super(props);
        //console.log('vista rapida props', props)
        //console.log(filtered);
        this.handleInfoAutoComplete = this.handleInfoAutoComplete.bind(this);
        this.state = {
            load:true,
            listObjectives:{},
            listAllObjectivesActives:[],
            listDowntime:{},
            listUptime:{},
            listPartial:{},
            newList:[],
            maxSteps:0,
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, h:mm:ss a")),
            filtro:false,
            isInfo:null,
            open: false,
            objNameModal: '',
            intervalId: null,
        };   
    }
    tick=()=>{
        window.location.reload()
        //console.log('recarga cada 15 minutos')
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        sessionStorage.setItem("listsLoads",false)
        this.setState({
            load:true,
            listObjectives:{},
            listAllObjectivesActives:[],
            listDowntime:{},
            listUptime:{},
            listPartial:{},
            newList:[],
            maxSteps:0,
            counter:0,
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, h:mm:ss a")),
            filtro:false,
            isInfo:null,
            
        })
        this.processData()
      }
    componentDidMount() {
        this.processData()
        const newInterval = setInterval(
            () => this.tick(),
            900000
        )
        this.setState({intervalId: newInterval})
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    componentDidUpdate(prevProps, prevState) {
        /* CUANDO LISTA OBTIENE DISPONIBILIDAD EN TODOS LOS OBJETIVOS VUELVE A LLAMAR A PROCESS*/
        //console.log('up',this.state.newList.length,this.state.listAllObjectivesActives.length  )
        if(this.state.newList.length!==0 && this.state.newList.length===this.state.listAllObjectivesActives.length ){
            //console.log('listas iguales en up')
            //console.log('update', this.state.newList.length, this.state.listAllObjectivesActives.length)
            this.processData()
        }
    }
    /*FUNCION QUE LLAMA DISPONIBILIDAD*/
    getFetchs = (objectiveParams, user, token) =>{
        //console.log(objective, date, token, user,monitor)
        return new Promise(resolve => {
            setTimeout(() => {
                getAvailabilityObjetive(objectiveParams.objetivo_id, 'h', user, token).then(data => {
                    //SE ESTABLECE DISPONIBILIDAD GLOBAL
                    objectiveParams["disponibilidad"]=parseFloat((data.data.uptime+data.data.parcial+data.data["no monitoreo"]+data.data['evento_cliente']).toFixed(2))
                    //console.log('fetch vr')
                    resolve(objectiveParams);
                })
                
            }, 1);
        });
    }
    processData = () => {
        const {newList, listAllObjectivesActives, listObjectives, maxSteps}=this.state
        //console.log('process vr')
        var countPasos=0
        if(sessionStorage.getItem("listsLoadsDisponibilidad")==="true"){
            //console.log('con cache de disponibilidad')
            var listaObjetivosOnlineDisponibilidad=JSON.parse(sessionStorage.getItem("listaObjetivosOnlineDisponibilidad"))
            //console.log(listaObjetivosOnlineDisponibilidad)
            if(maxSteps!==0){
                countPasos=maxSteps
            }else{
                Object.keys(listaObjetivosOnlineDisponibilidad).map(ele=>{
                    (listaObjetivosOnlineDisponibilidad[ele]).map(obj=>{
                        var Pasos=(obj.Pasos.length)
                        if(Pasos>countPasos){
                            countPasos=Pasos
                        }
                    })
                })
            }
            //console.log('prcess',countPasos, maxSteps)
            this.setState({
                listObjectives:listaObjetivosOnlineDisponibilidad,
                listDowntime:listaObjetivosOnlineDisponibilidad.Downtime,
                listUptime:listaObjetivosOnlineDisponibilidad.Uptime,
                listPartial:listaObjetivosOnlineDisponibilidad.Partial,
                load:false,
                maxSteps:countPasos,
                newList:[],
                
            })
        }else{
            //console.log('sin cache de disponibilidad')
            /*UNA VEZ QUE PASA POR TODOS LOS OBJETIVOS TRAYENDO DISPONIBILIDAD*/
            if(newList.length!==0 && newList.length===listAllObjectivesActives.length){
                //console.log('listas iguales')
                Object.keys(listObjectives).map(key=>{
                    //console.log(key)
                    Object.keys(listObjectives[key]).map(ele=>{
                        newList.map(newEle=>{
                            //console.log('una=>>>',newEle.objetivo_id,'dos=>>>',listObjectives[key][ele].objetivo_id)
                            if(newEle.objetivo_id===listObjectives[key][ele].objetivo_id){
                                var Pasos=(newEle.Pasos.length)
                                if(Pasos>countPasos){
                                    countPasos=Pasos
                                }
                                if(newEle.estado==="No monitoreo"){
                                    newEle.disponibilidad=0
                                }
                                listObjectives[key][ele]=newEle
                            }
                        })
                        //console.log(listObjectives[key][ele])
                    })
                    //console.log('antes',listObjectives[key])
                    listObjectives[key].sort(function (a, b) {
                        return (a.disponibilidad - b.disponibilidad);
                    });
                    //console.log('despues', listObjectives[key])
                })
                //console.log(countPasos)
                sessionStorage.setItem("listaObjetivosOnlineDisponibilidad",JSON.stringify(listObjectives))
                sessionStorage.setItem("listsLoadsDisponibilidad",true)
                this.setState({
                    listObjectives:listObjectives,
                    listDowntime:listObjectives.Downtime,
                    listUptime:listObjectives.Uptime,
                    listPartial:listObjectives.Partial,
                    maxSteps:countPasos,
                    load:false,
                    newList:[],
                    //counter:0
                })
            }else{
                //console.log('listas distintas')
                var user=sessionStorage.getItem("user")
                var token=sessionStorage.getItem("key")
                const allowed = ['Uptime', 'Downtime', 'Partial']
                var filtered={}
                var listAllActive={}
                //OBTIENE LISTA DE OBJETIVOS DESDE SESSION O VA A BUSCAR
                if(sessionStorage.getItem("listsLoads")==="true"){
                    //console.log('hay session globales ')
                    var raw =JSON.parse(sessionStorage.getItem("listaData"))
                    //console.log(raw)
                    var actives=JSON.parse(sessionStorage.getItem("listaDataActive"))
                    listAllActive=actives
                    //filtered= Object.keys(raw).filter(key => allowed.includes(key)).reduce((obj, key) => {obj[key] = raw[key];return obj;}, {});
                    filtered={"Uptime":raw.Uptime, "Partial":raw.Partial, "NoMonitoring": raw.NoMonitoring, "Downtime":raw.Downtime}
                    //console.log(filtered)
                    Object.keys(filtered).map(key=>{
                        filtered[key].map(objectiveParams=>{
                            if(objectiveParams.estado!=="No monitoreo"){
                                var data =this.getFetchs(objectiveParams, user, token)
                                data.then( value=>{
                                    if(objectiveParams.objetivo_id===value.objetivo_id){
                                        objectiveParams=value
                                        this.setState(data=>({
                                            newList:[...data.newList, value]
                                        }))
                                    }
                                })
                            }else{
                                this.setState(data=>({
                                    newList:[...data.newList, objectiveParams]
                                }))
                            }
                        }) 
                    })
                    this.setState({
                        listObjectives:filtered,
                        listAllObjectivesActives:listAllActive
                    })
                }else{
                    //console.log('sin session global')
                    let token = sessionStorage.getItem('key')
                    let user_id = sessionStorage.getItem('user')
                    //console.log('carga sin cache de objetivos globales vista rapida')

                    /*OBTIENE OBJETIVOS POR ESTADO*/
                    getObjectives(user_id, token).then(data=>{
                        //console.log(data)
                        if (data.status === 1 || data.status === 5) {
                            localStorage.setItem('isAuthenticated', false);   
                        } else {
                            let dataSeries = []
                            let dataServices = []
                            let checked = []
                            let actives=[]
                            dataServices.push('Todos')
                            checked.push(0)
                            Object.keys(data).map((keyType) => {
                                if (keyType != 'Services' && keyType != 'ServicesUnified') {
                                    let serie = data[keyType]
                                    Object.keys(serie).map((key) => {
                                        serie[key].nombre=(serie[key].nombre.replace("/", "|"))
                                        dataSeries.unshift(serie[key])
                                        actives.unshift(serie[key])
                                    })
                                } else if (keyType == 'ServicesUnified') {                            
                                    let serie = data[keyType]
                                    Object.keys(serie).map((key) => {
                                        checked.push(parseInt(key)+1)
                                        dataServices.push(serie[key])
                                    })
                                }
                            })
                            //console.log('process vr data', dataSeries)
                            actives.sort(function (a, b) {
                                return (a.orden - b.orden);
                            });
                            dataSeries.sort(function (a, b) {
                                return (a.orden - b.orden);
                            });
                            listAllActive=actives
                            sessionStorage.setItem("listaData",JSON.stringify(data))
                            sessionStorage.setItem("listaDataActive",JSON.stringify(actives))
                            sessionStorage.setItem("listaObjetivosOnline",JSON.stringify(dataSeries))
                            sessionStorage.setItem("dataServices",JSON.stringify(dataServices))
                            sessionStorage.setItem("checked",JSON.stringify(checked))
                            sessionStorage.setItem("listsLoads",true)
                            var raw=data
                            //{Uptime: Array(8), Partial: Array(0), Downtime: Array(3)}//
                            filtered={"Uptime":data.Uptime, "Partial":data.Partial, "NoMonitoring": data.NoMonitoring, "Downtime":data.Downtime}
                            //filtered = Object.keys(raw).filter(key => allowed.includes(key)).reduce((obj, key) => {obj[key] = raw[key];return obj;}, {});
                            Object.keys(filtered).map(key=>{
                                filtered[key].map(objectiveParams=>{
                                    if(objectiveParams.estado!=="No monitoreo"){
                                        var data =this.getFetchs(objectiveParams, user, token)
                                        data.then( value=>{
                                            if(objectiveParams.objetivo_id===value.objetivo_id){
                                                objectiveParams=value
                                                this.setState(data=>({
                                                    newList:[...data.newList, value]
                                                }))
                                                //console.log('actualiza new list', this.state.newList)
                                            }
                                        })
                                    }else{
                                        this.setState(data=>({
                                            newList:[...data.newList, objectiveParams]
                                        }))
                                    }
                                    //console.log("1", this.state.newList)
                                }) 
                            })
                            //console.log(listAllActive)
                            this.setState({
                                listObjectives:filtered,
                                listAllObjectivesActives:listAllActive,
                            })
                        }
                    })
                }    
            }
        }
    }

    handleInfoAutoComplete(info) {
        //const { params } = this.props;
        //const {listObjectives}=this.state
        var saveList=JSON.parse(sessionStorage.getItem("listaObjetivosOnlineDisponibilidad"))
        var newFilterService={}
        Object.keys(saveList).map(ele=>{
            var newList=[]
            if(saveList[ele].length>0){
                saveList[ele].map(obj=>{
                    info.map(serviceFilter=>{
                        var filterService=(serviceFilter.servicio)
                        if(obj.nombre_servicio_unificado===filterService){
                            newList.push(obj)
                        }
                    })
                })
            }
            newFilterService[ele]=newList
            
        })
        if(info.length===0){
            newFilterService=JSON.parse(sessionStorage.getItem("listaObjetivosOnlineDisponibilidad"))
        }
        this.setState({
            listObjectives:newFilterService,
        })
    }
    

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleOpen = event => {       
        const objId = event.currentTarget.id
        const objName = event.currentTarget.value
        //console.log(objId, objName, this.state.open)
            this.setState({
                open: true,
                objIdModal: objId,
                objNameModal: objName
            })      
    };
    
    handleClose = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            open: false,
        })
    };

    render() {
        
        const {load,  listObjectives, maxSteps, dateMoment, isInfo, open,
            objIdModal,
            objNameModal} = this.state;
        //console.log('render',listObjectives)
        const showIsInfo = Boolean(isInfo);
        //console.log('render fast', load)
        const { classes } = this.props;
        //console.log(downList)
        if (load===true) {
            //console.log('vista rapida render carga')
            return(
                <PerfectScrollbar>
                    <Typography
                        variant="h5"
                        align="center"
                    >
                    <CircularProgress
                        variant="indeterminate"
                        size={24}
                        thickness={4}
                    />
                    <br/>
                        Cargando Información...
                    </Typography>
               </PerfectScrollbar>
            )
        }else{
            //console.log('vista rapida render final', listObjectives)
            return(
                <Portlet>
                    <PortletHeader 
                    >
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >   
                            <Grid 
                                item
                                xs={10}
                                sm={6}
                                xl={6}
                            >   
                                <FilterService InfoAutoComplete={this.handleInfoAutoComplete}/>
                                
                            </Grid>
                            <Grid
                                item
                                xs={2}
                                sm={6}
                                xl={6}>
                                <Grid
                                container
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                                style={{textAlign:"right"}}
                                >
                                    <Grid item 
                                        xs={2}
                                        xl={2}>
                                        <IconButton
                                        onClick={this.handleShowIsInfo}
                                        >
                                        <HelpIcon color="infoIcon"/>
                                    </IconButton>
                                        
                                    </Grid>
                                    <Grid item 
                                        xs={1}
                                        xl={1}
                                        style={{flexBasis:"0%"}}>
                                        
                                        <Hidden mdDown>
                                        <Avatar variant="rounded" className={classes.rounded}>
                                            <UpdateIcon /> 
                                        </Avatar>
                                        </Hidden>
                                    </Grid>
                                    <Grid item 
                                        xs={6}
                                        xl={6}>
                                        <Hidden mdDown>
                                            <Typography noWrap  className={classes.updateTime} style={{textAlign:"left"}}  >
                                                    &nbsp; Última actualización: {dateMoment} 
                                            </Typography>
                                        </Hidden>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </PortletHeader>
                    <PerfectScrollbar>
                    <PortletContent>
                        <Table >
                            <TableRow className={classes.tableRow}>

                                <TableCell className={classes.monitoreos} colSpan={2}>
                                
                                <Typography className={classes.headerTableText} style={{fontSize:"18px"}}>Estado Actual de Monitoreos</Typography></TableCell>
                                <Desktop><TableCell className={classes.stepAlign } colSpan={maxSteps}><Typography className={classes.headerTableText} style={{fontSize:"18px"}} >Estado Actual Pasos</Typography></TableCell></Desktop>
                                <Desktop>
                                    <TableCell className={classes.Tendencia }>
                                        <Typography className={classes.headerTableText} style={{fontSize:"18px"}}>Tendencia</Typography>
                                        <Typography className={classes.headerTableText} style={{fontSize:"15px"}}>(Últ. 24 Horas) </Typography>
                                    </TableCell></Desktop>
                                <TableCell className={classes.alignRight}>
                                    <Typography className={classes.headerTableText} style={{fontSize:"18px"}}>Disponibilidad Global </Typography>
                                    <Typography className={classes.headerTableText} style={{fontSize:"15px"}}>(Últ. Hora) </Typography>
                                    </TableCell>
                            </TableRow>
                            <AvailabilityObjective data={listObjectives} maxSteps={maxSteps} handleOpen={this.handleOpen} handleClose={this.handleClose}/>
                        </Table>
                        <Popover
                            anchorEl={isInfo}
                            open={showIsInfo}
                            onClose={this.handleCloseIsInfo}
                            className={classes.popover}
                            >
                            <PortletContent className={classes.popoverPorlet}>
                                <Grid className={classes.buttonClosed} >
                                    <IconButton className={classes.buttonClosed} onClick={this.handleCloseIsInfo}><ClearIcon/></IconButton>
                                </Grid>
                                <Typography variant="body1" className={classes.textColorPopover} >Muestra estado de objetivos y/o servicios, ordenados por indisponibilidad de la última medición y 
                                del periodo de la Última hora representado por el porcentaje de Uptime.

                                La Disponibilidad de la última medición se representa por colores:
                                </Typography>
                                <Divider/>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    
                                    <StopIcon color="primary" /><Typography variant="body2" className={classes.textColorPopover}>: Indica Downtime Global</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}>: Indica Downtime Parcial</Typography>
                                </Grid>
                                <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                >
                                    <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}>: Indica Uptime</Typography>
                                </Grid>
                                <Divider/>
                                <Typography variant="body1" className={classes.textColorPopover}> 
                                    Adicionalmente se muestra información de último estado del paso ordenados
                                    por indisponibilidad y la Tendencia de la disponibilidad Global en la ultima semana.
                                </Typography>
                            
                            </PortletContent>
                        </Popover>
                        <Modal
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                                open={open}
                                onClose={this.handleClose}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                closeAfterTransition
                                //className={classes.tag0}
                                disableAutoFocus={true}
                                disableEnforceFocus={true}
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 500,
                                }}
                            >                                    
                            <Fade in={open}>
                                <PerfectScrollbar style={{position:"static"}}>
                                <div className={classes.div}>                             
                                    <ListObjectiveModal obj={objIdModal} objName={objNameModal} listObjectives={listObjectives} handleClose={this.handleClose}/>                        
                                </div>
                                </PerfectScrollbar>
                            </Fade>
                        </Modal>
                    </PortletContent>
                    </PerfectScrollbar>
                </Portlet>
            )
        }
    }
}


export default compose(withRouter, withStyles(styles))(FastView);